import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteTrainingSessionPhase, getTrainingSessionPhaseSingle } from "../../../../services/training-session";
import { emptyTrainingSessionPhase, TrainingSessionPhase } from "../../../../interfaces/training-session";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionPhaseDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionPhaseDelete(props: CoachTrainingSessionPhaseDeleteProps) {
    const [trainingSessionPhase, setTrainingPhase] = useState<TrainingSessionPhase>(emptyTrainingSessionPhase);

    const handleDelete = () => {
        deleteTrainingSessionPhase(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionPhaseSingle(props.id)
            .then(response => {
                setTrainingPhase(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-phase-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session_phase") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSessionPhase.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSessionPhase.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_phase_message"
                                values={{
                                    training_session_phase_name: trainingSessionPhase.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
